import keys from '@debbie/common/dist/cache/keys.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { courts } from '@debbie/common/dist/court/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { Entity, addressToString } from '@debbie/common/dist/index.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions, toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import { TribunalCaseType } from '@debbie/common/dist/tribunal/cases/types.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { interactionsEntity } from '@debbie/cortex/dist/interactions/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTemplatesMap } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import { updatesEntity } from '@debbie/cortex/dist/updates/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { encodeText, getSubjectContent, parseText, } from '../../../../utils/templates.js';
import { DocumentsPicker } from '../../../documents/index.js';
import NewEditor from '../../../editor/Editor.js';
import { useEditorState } from '../../../editor/hooks.js';
import { htmlToPlainText } from '../../../editor/utils.js';
import { Button, ButtonGroup, Checkbox, Modal, SearchInput, } from '../../../index.js';
import { TemplateSearch } from '../../../interactions/index.js';
import { PDFTemplatePreviewModal } from '../../../interactions/PDFTemplatePreview.js';
import PreviewInteraction from '../../../interactions/PreviewInteraction.js';
import { getDocumentsFromStorage, setLocalModel, } from './Betalingspaakrav/utils/index.js';
const Fogedrekvisition = (props) => {
    const lang = useSelector((s) => s.lang);
    const usersLoadable = useUsers();
    const allUsers = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const tenant = useTenant();
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const collectorId = singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId);
    const templatesMapLoadable = useTemplatesMap();
    const templatesMap = h.hasData(templatesMapLoadable)
        ? templatesMapLoadable.data
        : {};
    const collectorLoadable = useCollector(collectorId || undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.EMAIL, propertyTypes || undefined, tenant);
    const [loading, setLoading] = useState(false);
    const [emailTemplateId, setEmailTemplateId] = useState(null);
    const subjectState = useEditorState();
    const bodyState = useEditorState();
    const emailAttachmentState = useEditorState();
    const [emailPreviewModalOpen, setEmailPreviewModalOpen] = useState(false);
    const [emailAttachmentTemplateId, setEmailAttachmentTemplateId] = useState(null);
    const [emailAttachmentPreviewModalOpen, setEmailAttachmentPreviewModalOpen] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const contactPerson = customer && singleCase && getContactPerson(customer, singleCase);
    const [court, setCourt] = useState();
    const [documentState, setDocumentReactState] = useState({
        addCourtFeeToCase: true,
        addCourtDisbursementToClientBilling: true,
        addCourtFeeToClientBilling: true,
        sendInfoToEconomyResponsible: true,
        ...getDocumentsFromStorage(),
    });
    const [attachDocument, _setAttachDocument] = useState(false);
    const setAttachDocument = (attach) => {
        _setAttachDocument(attach);
        localStorage.setItem('fogedrekvisitionAttachDocument', attach ? '1' : '0');
    };
    useEffect(() => {
        const attach = localStorage.getItem('fogedrekvisitionAttachDocument');
        if (attach === '1') {
            _setAttachDocument(true);
        }
    }, []);
    const defaultsLoadedRef = React.useRef(false);
    useEffect(() => {
        if (defaultsLoadedRef.current) {
            return;
        }
        if (tenant && creditor && h.hasData(templatesMapLoadable)) {
            defaultsLoadedRef.current = true;
            const tenantEmailTempalteId = tenant?.settings?.tribunal?.caseTypes &&
                tenant.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition] &&
                tenant.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition]
                    ?.defaultEmailTemplateId;
            const creditorEmailTempalteId = creditor?.settings?.tribunal?.caseTypes &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition] &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition]?.defaultEmailTemplateId;
            const emailTemplateId = creditorEmailTempalteId || tenantEmailTempalteId;
            if (emailTemplateId) {
                const emailTemplate = templatesMap[emailTemplateId];
                if (emailTemplate) {
                    setEmailTemplateId(emailTemplateId);
                    if (emailTemplate.subject) {
                        subjectState.overwriteEditorContent(encodeText(emailTemplate.subject, mentionSuggestions));
                    }
                    bodyState.overwriteEditorContent(encodeText(emailTemplate.html, mentionSuggestions));
                }
            }
            const tenantEmailAttachmentTempalteId = tenant?.settings?.tribunal?.caseTypes &&
                tenant.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition] &&
                tenant.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition]
                    ?.defaultEmailAttachmentTemplateId;
            const creditorEmailAttachmentTempalteId = creditor?.settings?.tribunal?.caseTypes &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition] &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKFogedrekvisition]?.defaultEmailAttachmentTemplateId;
            const emailAttachmentTemplateId = creditorEmailAttachmentTempalteId || tenantEmailAttachmentTempalteId;
            if (emailAttachmentTemplateId) {
                const attachmentTemplate = templatesMap[emailAttachmentTemplateId];
                if (attachmentTemplate) {
                    setEmailAttachmentTemplateId(emailAttachmentTemplateId);
                    emailAttachmentState.overwriteEditorContent(encodeText(attachmentTemplate.html, mentionSuggestions));
                    _setAttachDocument(true);
                }
            }
        }
    }, [creditor, tenant, templatesMap]);
    const setDocumentState = (addToState) => {
        const newState = {
            ...documentState,
            ...addToState,
        };
        setLocalModel(newState);
        setDocumentReactState(newState);
    };
    const [economyResponsibleUserId, setEconomyResponsibleUserId] = useState(localStorage.economyResponsibleUserId || null);
    const getCourt = () => {
        if (court || court === null) {
            return court;
        }
        const _court = contactPerson &&
            contactPerson.details.courtId &&
            courts.find((c) => contactPerson.details.courtId &&
                [c.id, c.courtId].includes(contactPerson.details.courtId));
        if (_court) {
            return _court;
        }
        return null;
    };
    const createFogedrekvisition = async () => {
        if (selectedDocuments.length === 0) {
            confirm('Du har ikke valgt nogen dokumenter til vedhæftning. Er du sikker på, at du vil fortsætte?');
        }
        setLoading(true);
        try {
            if (singleCase) {
                await tribunalAPI.createTribunalJob({
                    type: DKTribunalJobType.CreateFogedrekvisition,
                    data: {
                        courtId: getCourt()?.courtId || '',
                        fileIds: selectedDocuments.map((d) => d.fileId),
                        sendInfoToEconomyResponsible: documentState.sendInfoToEconomyResponsible,
                        economyResponsibleUserId: economyResponsibleUserId || undefined,
                        addCourtFeeToCase: documentState.addCourtFeeToCase,
                        addCourtFeeToClientBilling: documentState.addCourtFeeToClientBilling,
                        addCourtDisbursementToClientBilling: documentState.addCourtDisbursementToClientBilling,
                        emailSubject: getSubjectContent(htmlToPlainText(parseText(subjectState.html, mentionSuggestions))),
                        emailBody: htmlToPlainText(parseText(bodyState.html, mentionSuggestions)),
                        emailHTML: parseText(bodyState.html, mentionSuggestions),
                        emailTemplateAttachments: attachDocument && emailAttachmentTemplateId
                            ? [
                                {
                                    templateId: emailAttachmentTemplateId,
                                    fileName: (templatesMap[emailAttachmentTemplateId] &&
                                        templatesMap[emailAttachmentTemplateId].fileName) ||
                                        null,
                                    content: parseText(emailAttachmentState.html, mentionSuggestions),
                                },
                            ]
                            : undefined,
                    },
                    caseId: singleCase.caseId,
                });
                q.invalidate(keys.write.create(tribunalJobsEntity));
                q.invalidate([...keys.write.create(updatesEntity)]);
                q.invalidate([...keys.write.create(caseVouchersEntity)]);
                q.invalidate([...keys.write.create(interactionsEntity)]);
                props.onCreated && props.onCreated();
            }
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
    };
    return (React.createElement("div", null,
        React.createElement("h3", null, lang.tribunal.jurisdiction),
        React.createElement(SearchInput, { placeholder: lang.documents.selectCourt, searchAll: (q) => {
                return courts
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.id,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c,
                }));
            }, static: getCourt() && getCourt()?.name, onRemoveStatic: () => {
                setCourt({
                    court: null,
                });
            }, onSelect: (court) => {
                setCourt({
                    ...court,
                });
            }, searchDelay: 0, forceOpen: true }),
        React.createElement("h3", null, "Tekst i e-mail"),
        singleCase && customer && (React.createElement(TemplateSearch, { case: singleCase, customer: customer, templateType: TemplateType.EMAIL, onChange: (content, subject, templateId) => {
                bodyState.overwriteEditorContent(content);
                setEmailTemplateId(templateId);
                if (subject) {
                    subjectState.overwriteEditorContent(subject);
                }
            } })),
        React.createElement(NewEditor, { hideControls: true, compact: true, singleLine: true, placeholder: lang.interactions.subject, mentions: toEditorMentions(mentionSuggestions), onChange: subjectState.onChange, initialContent: subjectState.editorContent }),
        React.createElement("br", null),
        React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: bodyState.onChange, initialContent: bodyState.editorContent }),
        React.createElement("br", null),
        React.createElement(Button, { onClick: () => setEmailPreviewModalOpen(true), size: "small", theme: "secondary" }, "Forh\u00E5ndsvisning"),
        React.createElement("br", null),
        emailPreviewModalOpen && (React.createElement(Modal, { onToggle: () => setEmailPreviewModalOpen(!emailPreviewModalOpen), header: lang.interactions.preview }, emailServer && singleCase && (React.createElement(PreviewInteraction, { interaction: {
                templateId: emailTemplateId || null,
                direction: Direction.OUTGOING,
                state: OutgoingState.SENT,
                type: InteractionType.Email,
                attachments: [],
                referenceId: singleCase.caseId,
                referenceType: Entity.Case,
                details: {
                    server: emailServer.id,
                    subject: getSubjectContent(htmlToPlainText(parseText(subjectState.html, mentionSuggestions))),
                    from: `${emailServer.fromName} <${emailServer.fromEmail}>`,
                    replyTo: collector?.replyTo,
                    body: parseText(bodyState.html, mentionSuggestions),
                    html: parseText(bodyState.html, mentionSuggestions),
                    to: court?.emailFogedretIndleveringFogedrekvisition ||
                        'info@example.com',
                },
                minVisibilityRole: 'client',
            } })))),
        React.createElement("br", null),
        React.createElement(Checkbox, { placeholder: "Tilf\u00F8j en brevskabelon som vedh\u00E6ftning til e-mailen", checked: attachDocument, onChange: (e) => setAttachDocument(e.target.checked) }),
        attachDocument && (React.createElement("div", null,
            singleCase && customer && (React.createElement(TemplateSearch, { case: singleCase, customer: customer, templateType: TemplateType.LETTER, onChange: (content, subject, templateId) => {
                    console.log(content, subject, templateId);
                    setEmailAttachmentTemplateId(templateId);
                    emailAttachmentState.overwriteEditorContent(content);
                } })),
            emailAttachmentTemplateId && singleCase && (React.createElement(React.Fragment, null,
                React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: emailAttachmentState.onChange, initialContent: emailAttachmentState.editorContent }),
                React.createElement("br", null),
                React.createElement(Button, { onClick: () => setEmailAttachmentPreviewModalOpen(true), size: "small", theme: "secondary" }, "Forh\u00E5ndsvisning"),
                emailAttachmentPreviewModalOpen && (React.createElement(PDFTemplatePreviewModal, { caseId: singleCase.caseId, templateId: emailAttachmentTemplateId, body: parseText(emailAttachmentState.html, mentionSuggestions), onToggle: () => setEmailAttachmentPreviewModalOpen(!emailAttachmentPreviewModalOpen) })))))),
        React.createElement("br", null),
        React.createElement("h3", null, lang.tribunal.economy),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToCase, checked: documentState.addCourtFeeToCase, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtFeeToCase: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtDisbursementToClientBilling, checked: documentState.addCourtDisbursementToClientBilling, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtDisbursementToClientBilling: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToClientBilling, checked: documentState.addCourtFeeToClientBilling, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    addCourtFeeToClientBilling: e.target.checked,
                });
            } }),
        React.createElement(Checkbox, { placeholder: lang.documents.sendInfoAboutRequisitionToRes, checked: documentState.sendInfoToEconomyResponsible, onChange: (e) => {
                setDocumentState({
                    ...documentState,
                    sendInfoToEconomyResponsible: e.target.checked,
                });
            } }),
        documentState.sendInfoToEconomyResponsible && (React.createElement(SearchInput, { searchAll: (q) => allUsers
                ? allUsers
                    .filter((t) => (`${t.firstName} ${t.lastName}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1 ||
                    q.length === 0) &&
                    isCaseworker(t.role))
                    .map((t) => ({
                    key: t.id,
                    heading: `${t.firstName} ${t.lastName}`,
                    subheading: t.role,
                    returnData: t,
                }))
                : [], onSelect: (result) => {
                setEconomyResponsibleUserId(result.id);
                localStorage.setItem('economyResponsibleUserId', result.id ?? '');
            }, static: (() => {
                const user = allUsers &&
                    allUsers.find((t) => t.id === economyResponsibleUserId);
                return ((user && `${user.firstName} ${user.lastName}`) ||
                    economyResponsibleUserId);
            })(), onRemoveStatic: () => {
                setEconomyResponsibleUserId('');
                localStorage.setItem('economyResponsibleUserId', '');
            }, searchDelay: 0, forceOpen: true, placeholder: lang.documents.responsible })),
        singleCase && documents && documents.length > 0 ? (React.createElement(DocumentsPicker, { documents: documents, onChange: (docs) => setSelectedDocuments(docs), caseId: singleCase.caseId })) : (React.createElement("p", null, lang.tribunal.noFoundation)),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { onClick: createFogedrekvisition, loading: loading }, lang.tribunal.createFogedrekvisition))));
};
export default Fogedrekvisition;
//# sourceMappingURL=Fogedrekvisition.js.map